// extracted by mini-css-extract-plugin
module.exports = {"terms_link":"Terms_terms_link__2BsKH"};